export default function Differentiation() {
  const features = [
    {
      title: '실시간 알림',
      description: '새로운 지원자가 있을 때 즉시 앱 푸시로 알려드립니다',
      image: 'https://public.readdy.ai/ai/img_res/e5378dc8c78175d8b6f5109d7ce395b7.jpg'
    },
    {
      title: '간편한 관리',
      description: '지원자 정보를 한눈에 확인하고 바로 연락할 수 있습니다',
      image: 'https://readdy.ai/api/search-image?query=professional%20recruitment%20management%20dashboard%20interface%20showing%20applicant%20profiles%20and%20contact%20information%20cards%2C%20modern%20clean%20UI%20design%20with%20organized%20layout%2C%20soft%20pastel%20color%20scheme%20with%20white%20background%2C%20elegant%20business%20application%20mockup%20with%20clear%20typography%20and%20icons%2C%20high%20resolution%20detailed%20view&width=800&height=600&seq=feature-management-hq-002&orientation=landscape'
    },
    {
      title: '스마트 매칭',
      description: '매장 특성에 맞는 최적의 인력을 AI가 추천해드립니다',
      image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20matching%20system%20visualization%20with%20glowing%20connection%20lines%20between%20profile%20icons%20and%20business%20locations%2C%20modern%20tech%20interface%20with%20soft%20blue%20and%20purple%20gradients%2C%20clean%20minimalist%20design%20showing%20AI%20recommendation%20algorithm%2C%20professional%20technology%20concept%20with%20elegant%20lighting%20and%20depth%2C%20high%20quality%20detailed%20rendering&width=800&height=600&seq=feature-ai-matching-hq-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-white rounded-full border border-gray-200 mb-6">
            <span className="text-sm font-medium text-gray-700" style={{ fontFamily: "'Pretendard', sans-serif" }}>핵심 기능</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
            온니잡만의 차별점
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            사장님의 채용을 더 쉽고 빠르게 만드는 특별한 기능들
          </p>
        </div>

        {/* Features */}
        <div className="space-y-24">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}
            >
              <div className="flex-1">
                <div className="relative rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto"
                  />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                  {feature.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
